import { Valence } from '@upright/common/model/types';
import { Bounds } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';

export function connectionPointForDataAreaBoundsAtValence(bounds: Bounds, valence: Valence) {
  const y = bounds.y1 + bounds.height / 2;
  if (valence === Valence.POSITIVE) {
    return { x: bounds.x2, y };
  }
  return { x: bounds.x1, y };
}
